import type { AppearancePreference } from './appearance'
import { updateProfile } from '../api/account'
import { USE_REAL_API } from './api'
import { APPEARANCE_ENABLED, useAppearanceStore } from '../store/appearance'

export async function saveAppearancePreference(next: AppearancePreference): Promise<boolean> {
  const before = useAppearanceStore.getState()
  if (!APPEARANCE_ENABLED || before.saving) return false
  if (before.preference === next) return true
  if (USE_REAL_API && !before.accountUserId) {
    useAppearanceStore.setState({ error: 'sign_in_required' })
    return false
  }

  useAppearanceStore.setState({ saving: true, error: null })
  useAppearanceStore.getState().setPreference(next)
  if (!USE_REAL_API) {
    useAppearanceStore.setState({ saving: false })
    return true
  }

  try {
    await updateProfile({ appearance_preference: next })
    const current = useAppearanceStore.getState()
    if (current.accountUserId !== before.accountUserId || current.sessionEpoch !== before.sessionEpoch) return false
    useAppearanceStore.setState({ saving: false })
    return true
  } catch {
    const current = useAppearanceStore.getState()
    if (current.accountUserId === before.accountUserId && current.sessionEpoch === before.sessionEpoch) {
      if (current.preference === next) current.setPreference(before.preference)
      useAppearanceStore.setState({ saving: false, error: 'save_failed' })
    }
    return false
  }
}
